/**
 * @module api/publicApi/publicUserApi
 */

import secureClient from 'lib/secure-client';
import apiUrl from 'shared_js/helpers/urlHelper/apiUrl';

/**
 * Retrieve account user info
 *
 */
function getAccountUserInfo() {
  return this.get(`${apiUrl}/user-profiles`, 'user');
}

/**
 * Retrieve user's banks
 * https://blueprint.bukalapak.io/t/users~bank~accounts~get~banks
 */
function getUserBanks() {
  return this.get(`${apiUrl}/banks`, 'user');
}

/**
 * Retrieve User Profile by ID
 *
 * @param {number} id - e.g. 12345
 */
function retrieveUserById(id) {
  return this.get(`${apiUrl}/users/${id}`, 'user');
}

/**
 * Sending TFA then Authenticate user by Device Id by
 *
 * @param {Object} headers
 * @param {string} headers.Bukalapak-Idetity - bukalapak identity, '117361FE-2EED-43BA-AF07-1B4056D303B5'
 * @param {string} headers.Bukalapak-OTP - bukalapak otp, '12345'
 * @param {string} headers.Bukalapak-OTP-Key - bukalapak otp key, '47c5495e-fb2c-4267-a896-23014afc7505'
 * @param {string} headers.Bukalapak-OTP-Device-ID - bukalapak device Id, 'ASD223SDA
 * @param {string} headers.Bukalapak-OTP-Method - bukalapak OTP method - 'sms',
 * @param {string} data.state - user state - 'active'
 */
function authenticateUser(headers, data) {
  return this.put(`${apiUrl}/users/tfa-status`, 'user', { headers, data });
}

/**
 * Get Banner List
 * https://blueprint.bukalapak.io/t/banners~banners~get~banners
 */
function retrieveBanners(type) {
  return this.get(`${apiUrl}/mitra/banners`, 'user', {
    // Limit hardcoded to 50. But backend should return less than 50.
    params: { type, limit: 50, offset: 0 },
  });
}

/**
 * Collection of public user api
 */
const publicUserApi = secureClient(
  {
    getAccountUserInfo,
    getUserBanks,
    retrieveUserById,
    authenticateUser,
    retrieveBanners,
  },
  'xhrPublicUserApi',
);

export default publicUserApi;
